import { JSX } from 'react';
import { Box } from '@mui/material';
import { statusTone, StatusTone } from '../email-finder-format';

/**
 * One chip for every one of the mini's status vocabularies: a scan's
 * complete / running / pending / cancelled / failed, a result's
 * new / existing, and the operator's own in_progress / pending / completed.
 * Soft fill, same hue border, same hue text, all from `--wf-` tokens so it
 * swaps with the theme.
 *
 * `label` is for a vocabulary whose stored value does not read as a label -
 * `in_progress` shown as "In Progress" - and defaults to the status itself.
 */
export const StatusChip: (props: { status: string, label?: string, dense?: boolean }) => JSX.Element =
    (props: { status: string, label?: string, dense?: boolean }): JSX.Element => {
        const tone: StatusTone = statusTone(props.status);

        return (
            <Box component="span"
                 sx={ {
                     display: 'inline-flex',
                     alignItems: 'center',
                     gap: '6px',
                     padding: props.dense ? '1px 8px' : '2px 10px',
                     borderRadius: 'var(--wf-r-pill)',
                     border: '1px solid',
                     borderColor: tone.line,
                     background: tone.fill,
                     color: tone.ink,
                     fontSize: props.dense ? '10.5px' : '11px',
                     fontWeight: 600,
                     letterSpacing: 'var(--wf-track-sm)',
                     textTransform: 'uppercase',
                     lineHeight: 1.7,
                     whiteSpace: 'nowrap',
                 } }>
                { props.label ?? (props.status || 'unknown') }
            </Box>
        );
    }
